import { Helmet } from "react-helmet";
import { Footer } from "@/components/Footer";
import { Tabs } from "@/components/ui/tabs";
import { ErrorBoundary } from "react-error-boundary";
import { TabsNavigation } from "@/components/family/TabsNavigation";
import { TabContent } from "@/components/family/TabContent";

const Family = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": "https://scienzahealth.com/family#webpage",
    "url": "https://scienzahealth.com/family",
    "name": "Family Care Platform - Scienza Health",
    "description": "Comprehensive family care monitoring and coordination platform for healthcare management",
    "isPartOf": {
      "@type": "WebSite",
      "@id": "https://scienzahealth.com/#website",
      "name": "Scienza Health",
      "url": "https://scienzahealth.com"
    },
    "primaryImageOfPage": {
      "@type": "ImageObject",
      "url": "https://scienzahealth.com/mcai_social_preview.png"
    },
    "about": {
      "@type": "HealthcareService",
      "name": "Family Care Monitoring Platform",
      "description": "Advanced family care monitoring and coordination tools for comprehensive healthcare management",
      "provider": {
        "@type": "Organization",
        "name": "Scienza Health",
        "url": "https://scienzahealth.com"
      },
      "audience": {
        "@type": "Audience",
        "audienceType": "Family caregivers and healthcare coordinators"
      }
    },
    "offers": {
      "@type": "Offer",
      "category": "Healthcare Monitoring",
      "description": "Family care coordination and monitoring platform"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://scienzahealth.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Family Care Platform",
          "item": "https://scienzahealth.com/family"
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Helmet>
        <title>Family Care Platform - Healthcare Monitoring & Coordination</title>
        <meta name="description" content="Comprehensive family care monitoring and coordination platform for healthcare management" />
        <meta name="keywords" content="family care, healthcare monitoring, patient care, elder care, care coordination" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
        <meta property="og:title" content="Family Care Platform" />
        <meta property="og:description" content="Comprehensive family care monitoring and coordination platform" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
        <h1 className="text-xl sm:text-2xl lg:text-4xl font-bold text-gray-900 mb-4 truncate">
          Family Care Platform
        </h1>
        
        <Tabs defaultValue="dashboard" className="space-y-4">
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <TabsNavigation />
            <TabContent />
          </ErrorBoundary>
        </Tabs>
      </div>
      <Footer />
    </div>
  );
};

const ErrorFallback = ({ error }: { error: Error }) => {
  return (
    <div className="p-4 rounded-lg bg-red-50 border border-red-200">
      <h2 className="text-lg font-semibold text-red-800 mb-2">Something went wrong</h2>
      <p className="text-red-600 break-words">{error.message}</p>
    </div>
  );
};

export default Family;